import { render, staticRenderFns } from "./CustomerDetailbyStatus.vue?vue&type=template&id=3bf7c363"
import script from "./CustomerDetailbyStatus.vue?vue&type=script&lang=js"
export * from "./CustomerDetailbyStatus.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetailbyStatus.vue?vue&type=style&index=0&id=3bf7c363&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports